// Modules
import { useState, useEffect } from 'react'
import { useTracking } from 'react-tracking'

interface UseAnalyticsProps {
    trackEvent: (data: Partial<unknown>) => void
}

export function useAnalytics(payload?: Record<string, string>, shouldCall: boolean = true): UseAnalyticsProps {
    const [isTracked, setIsTracked] = useState(false)
    const { trackEvent } = useTracking()

    useEffect(() => {
        if (!isTracked && shouldCall && payload) {
            trackEvent(payload)
            setIsTracked(true)
        }
    }, [isTracked, trackEvent, payload, shouldCall])

    return { trackEvent }
}
